export default "/img/NG.3780ae347adb0ea241f403c244f14a4e.png";